module.exports = __webpack_public_path__ + "img/Andaluza-14-min.d5bd30e9.jpg";